export const ASSIGNMENT_KEY_REQUEST_A_QUOTE = "request-a-quote"


// WEBPACK FOOTER //
// ./src/state/assignment-rule/AssignmentRuleKeys.ts